import "./buttondropdownmenu.scss"
import {Button, Menu, MenuButton, MenuItem, MenuList} from "@chakra-ui/react";
import React from "react";

interface IButtonDropdownMenu {
    icon: JSX.Element
    menuItems: { icon: JSX.Element, title: string, action: () => void }[]
}

const ButtonDropdownMenu = ({icon, menuItems}: IButtonDropdownMenu) => {
    return (
        <div className="Button-Drop-Down">
            <Menu>
                <MenuButton as={Button}>
                    {icon}
                </MenuButton>
                <MenuList>
                    {
                        menuItems.map((menuItem, index) => {
                            return (
                                <MenuItem key={index} onClick={menuItem.action}>
                                    {menuItem.icon}
                                    &nbsp;&nbsp;
                                    {menuItem.title}
                                </MenuItem>
                            );
                        })
                    }
                </MenuList>
            </Menu>
        </div>
    )
}

export default ButtonDropdownMenu